var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10.8337V12.8337C12.6667 13.2003 12.3667 13.5003 12 13.5003H11.3333V10.8337H12.6667ZM4.66667 10.8337V13.5003H4C3.63333 13.5003 3.33333 13.2003 3.33333 12.8337V10.8337H4.66667ZM8 2.16699C4.68667 2.16699 2 4.85366 2 8.16699V12.8337C2 13.9403 2.89333 14.8337 4 14.8337H6V9.50033H3.33333V8.16699C3.33333 5.58699 5.42 3.50033 8 3.50033C10.58 3.50033 12.6667 5.58699 12.6667 8.16699V9.50033H10V14.8337H12C13.1067 14.8337 14 13.9403 14 12.8337V8.16699C14 4.85366 11.3133 2.16699 8 2.16699Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioFilterIcon);
export default __webpack_public_path__ + "static/media/audio_filter_icon.e4012395ea1b2714e7e6f83efcdd8a9f.svg";
export { ForwardRef as ReactComponent };